module.exports = __webpack_public_path__ + "static/media/m-headshot-iya.805ffa6c.png";